// *https://www.registers.service.gov.uk/registers/country/use-the-api*
// import fetch from "cross-fetch";
import akmApi from "../../../../../../apis/akmApi";
import eduprimeApi from "../../../../../../apis/eduprimeApi";
import { CONFIG_AKM } from "../../../../../../config/ConfigAkm";
import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ThemeConsumer } from "react-bootstrap/esm/ThemeProvider";
import { CONFIG_API_BE } from "../../../../../../config";

function sleep(delay = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
}

export default function AutocompleteSearchSekolah(props) {
    const [open, setOpen] = React.useState(false);
    const [search, setSearch] = React.useState(null);
    const [options, setOptions] = React.useState([]);
    const loading = open && options.length === 0;

    React.useEffect(() => {
        if (search !== null) {
            (async () => {
                setOpen(true);
                await eduprimeApi
                    .get(CONFIG_API_BE.API_GET_SEKOLAH + props.idKota)
                    .then((data) => {
                        console.info("data sekolah", data.data.list_sekolah);
                        const listSchool = data.data.list_sekolah;
                        if (listSchool.length > 0) {
                            setOptions(data.data.list_sekolah);
                        } else {
                            setOptions([]);
                        }
                    })
                    .catch(function (error) {
                        console.error("Error Response Fetch City", error);
                    });
            })();
        }
        return () => {
            setSearch(null);
        };
    });

    return (
        <Autocomplete
            size="small"
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            getOptionSelected={(option, value) => option.NAMA_SEKOLAH === value.NAMA_SEKOLAH}
            getOptionLabel={(option) => option.NAMA_SEKOLAH}
            options={options}
            loading={loading}
            disableClearable={true}
            onChange={(event, value) => {
                console.info("value sekolah", value.ID_SEKOLAH);
                props.handleChangeSekolah(value.ID_SEKOLAH);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Cari School"
                    variant="outlined"
                    onChange={(event) => {
                        setSearch(event.target.value);
                    }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
}
